import { TextFieldProps } from '@mui/material';

export const commonInputProps: Partial<TextFieldProps> = {
  fullWidth: true,
  size: 'small',
  variant: 'outlined',
};
